module.exports = __webpack_public_path__ + "assets/img/pingmu.e43abf74.png";